function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
// Manages the OAuth flow by WebChannel messages to the browser to help with a pairing-based flow.
// See docs/pairing-architecture.md for exact structure of the messages.
import AuthorityStateMachine from '../../pairing/authority-state-machine';
import BaseAuthenticationBroker from '../base';
import OAuthErrors from '../../../lib/oauth-errors';
import setRemoteMetaData from './remote-metadata';
const PAIR_HEARTBEAT_INTERVAL = 1000;

let AuthorityBroker = /*#__PURE__*/function (_BaseAuthenticationBr) {
  _inherits(AuthorityBroker, _BaseAuthenticationBr);

  var _super = _createSuper(AuthorityBroker);

  function AuthorityBroker() {
    var _this;

    _classCallCheck(this, AuthorityBroker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "type", 'authority');

    _defineProperty(_assertThisInitialized(_this), "setRemoteMetaData", setRemoteMetaData);

    return _this;
  }

  _createClass(AuthorityBroker, [{
    key: "initialize",
    value: function initialize(options) {
      _get(_getPrototypeOf(AuthorityBroker.prototype), "initialize", this).call(this, options);

      const notifier = options.notifier,
            config = options.config;

      if (!config.pairingClients.includes(this.relier.get('clientId'))) {
        // only approved clients may pair
        throw OAuthErrors.toError('INVALID_PAIRING_CLIENT');
      } // The AuthorityStateMachine is responsible for driving the next steps of the pairing process.
      // It transitions between various pairing views.


      this.stateMachine = new AuthorityStateMachine({}, {
        broker: this,
        notifier,
        relier: this.relier
      });
    }
  }, {
    key: "fetch",
    value: function fetch() {
      return Promise.resolve().then(() => _get(_getPrototypeOf(AuthorityBroker.prototype), "fetch", this).call(this)).then(() => this.getSupplicantMetadata()).then(() => this.startHeartbeat());
    }
    /**
     * The heartbeat methods below communicate the 'fxaccounts:pair_heartbeat' message.
     * See the pairing documentation for the possible formats of the heartbeat message.
     * The authority never connects directly to either the channel server or the auth/oauth
     * servers, we get all status and error messages from the browser via the heartbeat.
     * @param {integer} interval
     */

  }, {
    key: "startHeartbeat",
    value: function startHeartbeat() {
      let interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAIR_HEARTBEAT_INTERVAL;
      this._heartbeatInterval = setInterval(() => this.heartbeat(), interval);
    }
  }, {
    key: "stopHeartbeat",
    value: function stopHeartbeat() {
      clearInterval(this._heartbeatInterval);
    }
  }, {
    key: "heartbeat",
    value: function heartbeat() {
      this.request(this._notificationChannel.COMMANDS.PAIR_HEARTBEAT).then(response => {
        if (response.err) {
          this.stateMachine.heartbeatError(response.err);
        } else if (response.suppAuthorized) {
          this.notifier.trigger('pair:supp:authorize');
        }
      });
    }
  }, {
    key: "getSupplicantMetadata",
    value: function getSupplicantMetadata() {
      const remoteMetaData = this.get('remoteMetaData');

      if (remoteMetaData) {
        return Promise.resolve(remoteMetaData);
      }

      return this.request(this._notificationChannel.COMMANDS.PAIR_REQUEST_SUPPLICANT_METADATA).then(response => {
        this.setRemoteMetaData(response);
        return this.get('remoteMetaData');
      });
    }
  }, {
    key: "afterPairAuthAllow",
    value: function afterPairAuthAllow() {
      // We use `request` instead of `send` despite not waiting for a response so we
      // can let the native side run the entire WebChannel handler.
      return this.request(this._notificationChannel.COMMANDS.PAIR_AUTHORIZE).then(() => {
        this.notifier.trigger('pair:auth:authorize');
      });
    }
  }, {
    key: "afterPairAuthDecline",
    value: function afterPairAuthDecline() {
      // We use `request` instead of `send` despite not waiting for a response so we
      // can let the native side run the entire WebChannel handler.
      return this.request(this._notificationChannel.COMMANDS.PAIR_DECLINE);
    }
  }, {
    key: "afterPairAuthComplete",
    value: function afterPairAuthComplete() {
      // We use `request` instead of `send` despite not waiting for a response so we
      // can let the native side run the entire WebChannel handler.
      return this.request(this._notificationChannel.COMMANDS.PAIR_COMPLETE);
    }
  }, {
    key: "request",
    value: function request(message) {
      let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Promise.resolve().then(() => {
        data.channel_id = this.relier.get('channelId'); //eslint-disable-line camelcase

        return this._notificationChannel.request(message, data);
      });
    }
  }]);

  return AuthorityBroker;
}(BaseAuthenticationBroker);

export { AuthorityBroker as default };